import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { appActions } from '../../app/reducer/app-reducer';

/*
    OAuth page is a simple wrapper to perform LP login for a user who was already authenticated
    on another portal. The mandatory "code" query param is the user's tully token. Nothing gets rendered here.
 */
//*********************************************
export class OAuth extends PureComponent {
  constructor(props) {
    super(props);

    const queryParams = parse(this.props.location.search);
    const authToken = queryParams.code;

    // check provided authToken, if none then redirect to login page
    if (!authToken) {
      console.log('going to /login');
      this.props.history.push('/login');
      return;
    }

    // attempt to login with the provided token
    this.props.loginUser('', '', authToken);
  }

  render = () => {
    console.log('OAuth.render()');
    return null;
  };
}

const mapStateToProps = (state, ownprops) => ({});

const wrapActions = {
  loginUser: appActions.loginUser
};

export const OAuthContainer = connect(
  mapStateToProps,
  wrapActions
)(OAuth);



// WEBPACK FOOTER //
// ./src/modules/login/components/OAuth.jsx